import { Route, AppId, createPageRoute } from '@lumapps/router';

export const termsAndConditionsRoute: Route = createPageRoute({
    slug: 'platform/terms-and-conditions',
    id: 'terms-and-conditions',
    appId: AppId.backOffice,
});
